import { supabase } from "@/lib/supabase";

export type FaqFeedbackValue = "helpful" | "notHelpful";

/**
 * Best-effort persistence of FAQ feedback to the backend so the admin summary
 * can aggregate which answers need improving. Failures are swallowed — the
 * local memory still keeps the visitor's own choice, and a missing backend
 * must never block the help center experience.
 */
export async function recordFaqFeedback(
  qKey: string,
  category: string,
  value: FaqFeedbackValue,
): Promise<void> {
  try {
    const { data } = await supabase.auth.getSession();
    const userId = data.session?.user?.id ?? null;
    await supabase.from("faq_feedback").insert({
      q_key: qKey,
      category: category || null,
      helpful: value === "helpful",
      user_id: userId,
    });
  } catch {
    /* backend unavailable, ignore */
  }
}